import { createContext, useContext, useState } from 'react'

const FormContext = createContext()

export const FormProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    // Event Type & Art Type
    ArtRunner: '',
    ArtType: null,
    categoryId: '',
    eventTypeId: '',

    // Event Details
    ShowName: null,
    ShowDetails: null,
    ShowDate: null,
    DoorOpens: null,
    StartTime: null,
    EndTime: null,
    isMidNight: false,

    // Venue Details
    VenueName: null,
    VenueAddress: null,
    latitude: null,
    longitude: null,

    // Artists
    AddArtists: null,
    preAddedArtist: [],

    // Personal Approval
    PersonallyApprove: false,
    NumberSpots: null,
    TotalSpots: null,
    Guests: false,
    SupportVenue: false,
    MultipleSignup: false,
    Requirements: null,

    // Auto Repeat
    AutoRepeat: false,
    RepeatType: null,
    RepeatStartDate: null,
    RepeatEndDate: null,
    DayWeek: null,
    WeekMonth: null,

    // Visibility
    VisibilityType: null,
    AlwaysVisible: 1,
    CustomDate: null,
    CustomTime: null,
    Settings: null,

    // Event Entry
    EventEntry: null,

    // Currency & Pricing
    currency: 'USD',
    currencySymbol: '$',
    exchangeRate: 1,
    baseCurrency: 'USD',

    // Ticket Pricing (for Ticket entry)
    VIPPrice: null,
    VIPSeats: null,
    VIPBookedSeats: null,
    economyPrice: null,
    economySeats: null,
    economyBookedSeats: null,
    displayVipPrice: null,
    displayEconomyPrice: null,

    // Payment Provider
    paymentProvider: null, // 'Stripe', 'Third-Party', or 'Free'
    ticketPageLink: null,

    // Free Entry
    freeSeats: null,
    freeBookedSeats: null,

    // Additional Fields
    TicketImages: null,
    Expect: null,
    Expect1: null,
    Expect2: null,
    EventPoster: [],

    // Backend specific fields
    VIPTicket: null, // Legacy field - consider removing
    EconomyPrice: null, // Legacy field - consider removing
    PageUrl: null, // Legacy field - consider removing
  })

  const [errors, setErrors] = useState({})

  // Helper function to reset form
  const resetForm = () => {
    setFormData({
      ArtRunner: '',
      ArtType: null,
      categoryId: '',
      eventTypeId: '',
      ShowName: null,
      ShowDetails: null,
      ShowDate: null,
      DoorOpens: null,
      StartTime: null,
      EndTime: null,
      isMidNight: false,
      VenueName: null,
      VenueAddress: null,
      latitude: null,
      longitude: null,
      AddArtists: null,
      preAddedArtist: [],
      PersonallyApprove: false,
      NumberSpots: null,
      TotalSpots: null,
      Guests: false,
      SupportVenue: false,
      MultipleSignup: false,
      Requirements: null,
      AutoRepeat: false,
      RepeatType: null,
      RepeatStartDate: null,
      RepeatEndDate: null,
      DayWeek: null,
      WeekMonth: null,
      VisibilityType: null,
      AlwaysVisible: 1,
      CustomDate: null,
      CustomTime: null,
      Settings: null,
      EventEntry: null,
      currency: '',
      currencySymbol: '',
      exchangeRate: 1,
      baseCurrency: '',
      VIPPrice: null,
      VIPSeats: null,
      VIPBookedSeats: null,
   
      economyPrice: null,
      economySeats: null,
      economyBookedSeats: null,

      displayVipPrice: null,
      displayEconomyPrice: null,
      paymentProvider: null,
      ticketPageLink: null,
      freeSeats: null,
      freeBookedSeats: null,
      TicketImages: null,
      Expect: null,
      Expect1: null,
      Expect2: null,
      EventPoster: [],
      VIPTicket: null,
      EconomyPrice: null,
      PageUrl: null,
    })
    setErrors({})
  }

  // Helper function to update nested fields
  const updateFormData = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }))
  }

  // Helper function to batch update multiple fields
  const batchUpdateFormData = (updates) => {
    setFormData(prev => ({
      ...prev,
      ...updates
    }))
  }

  return (
    <FormContext.Provider value={{
      formData,
      setFormData,
      errors,
      setErrors,
      resetForm,
      updateFormData,
      batchUpdateFormData
    }}>
      {children}
    </FormContext.Provider>
  )
}

export const useFormContext = () => {
  const context = useContext(FormContext)
  if (!context) {
    throw new Error('useFormContext must be used within a FormProvider')
  }
  return context
}